// Intro copy for tag hub pages (/tags/{slug}).
//
// The tags with the most public scenes across the network get a hand-written
// line; every other tag gets the template in `tagIntro`. Tags marked `both`
// in the vocabulary appear on girls and guys sites alike, so their copy stays
// gender-neutral. `{site}` becomes the site's name.
const TAG_INTROS = {
  amateur:
    "Real people, real chemistry: {site}'s amateur scenes keep it unscripted and close to the action.",
  anal: "Every anal scene on {site}, shot in full length with nothing cut away.",
  ass: "Scenes on {site} built around a great ass, from slow teasing to rough riding.",
  "big-dick":
    "Big dicks and the performers who can take them, in every {site} scene that features one.",
  "big-tits":
    "Big natural and enhanced tits, front and center in every {site} scene that shows them off.",
  blonde: "Blondes on {site}, every scene, newest first.",
  blowjob:
    "Sloppy, slow or deep: every {site} scene with a blowjob, newest first.",
  brunette: "Brunettes on {site}, every scene, newest first.",
  cowgirl:
    "Scenes on {site} where the performer on top sets the pace, riding cowgirl.",
  creampie: "Every {site} scene that finishes with a creampie.",
  cumshot: "Every {site} scene that ends with a cumshot, newest first.",
  deepthroat: "Deepthroat scenes on {site}, taken all the way down.",
  doggystyle:
    "Every {site} scene with doggystyle, shot from the angles that matter.",
  facial: "Every {site} scene that ends with a facial.",
  fingering: "Scenes on {site} that take their time with fingering.",
  interracial: "Interracial scenes on {site}, newest first.",
  lingerie:
    "Lingerie scenes on {site}: stockings, lace and sets that come off slowly.",
  massage:
    "Massage scenes on {site} that start with oil and hands and go further.",
  orgasm: "Scenes on {site} built around a real, visible orgasm.",
  petite: "Petite performers on {site}, in every scene that features them.",
  pov: "Point-of-view scenes on {site}, shot so you're the one in the room.",
  "small-tits": "Small, perky tits in every {site} scene that features them.",
  solo: "Solo scenes on {site}: one performer, the camera, and nobody else.",
  tattoo: "Tattooed performers on {site}, in every scene that shows the ink.",
  teen: "Young-looking performers in {site}'s teen 18+ scenes. Every performer is 18 or older.",
  threesome: "Threesomes on {site}, every scene, newest first.",
  tits: "Every {site} scene where the tits get the attention they deserve.",
  twink:
    "Twinks on {site}: slim, smooth and young-looking guys, all 18 or older.",
}

const fill = (text, siteName) => text.replaceAll("{site}", siteName)

// The intro line for a tag page: hand-written for the top tags, else a
// template naming the tag and the site.
export const tagIntro = ({ slug, label, siteName }) =>
  TAG_INTROS[slug]
    ? fill(TAG_INTROS[slug], siteName)
    : `Every ${siteName} scene tagged ${label.toLowerCase()}, newest first.`

// "Big Dick" and "Teen 18+" → "Big Dick and Teen 18+". Pair pages name both
// tags.
export const tagNames = (tags) => tags.map((tag) => tag.label).join(" and ")

// A label as it reads mid-sentence: lowercase, except all-caps terms such as
// POV, BBC or MILF.
const inSentence = (label) =>
  /[a-z]/.test(label) ? label.toLowerCase() : label

// The pair page's heading, and its title before " | {site}": "Anal Blowjob
// Videos".
export const pairHeading = (tags) =>
  `${tags.map((tag) => tag.label).join(" ")} Videos`

// A small, stable number for a pair, so each pair keeps the same intro
// wording on every render while other pairs read differently.
const pairSeed = (tags) =>
  [...tags.map((tag) => tag.slug).join("/")].reduce(
    (hash, char) => (hash * 31 + char.charCodeAt(0)) >>> 0,
    7,
  )

const PAIR_INTROS = [
  ({ count, tone, a, b, scenes, quality }) =>
    `${count} ${tone}${a} and ${b} ${scenes}${quality}, newest first.`,
  ({ count, tone, a, b, site, scenes, quality }) =>
    `${site} has ${count} ${tone}${scenes} tagged both ${a} and ${b}${quality}.`,
  ({ count, tone, a, b, site, scenes, quality }) =>
    `${count} ${tone}${site} ${scenes} that pair ${a} with ${b}${quality}.`,
  ({ count, tone, a, b, site, scenes, quality, one }) =>
    `Watch ${count} ${tone}${a} ${scenes} on ${site} that also ${one ? "features" : "feature"} ${b}${quality}.`,
]

// The pair page's one-sentence intro, naming its scene count: "23 sensual
// anal and blowjob scenes in Full HD 1080p, newest first." The wording
// rotates by pair, so pages don't all read the same. `copy` is the site's
// siteCopy entry: its `tone` (e.g. "sensual") goes before the tags, and its
// `quality` is said unless most of the page's scenes are 4K, which is said
// instead. Without an entry the sentence names neither.
export const pairIntro = ({
  tags,
  siteName,
  count,
  mostlyUhd = false,
  copy = null,
}) => {
  const [a, b] = tags.map((tag) => inSentence(tag.label))
  let quality = ""
  if (mostlyUhd) quality = " in 4K"
  else if (copy?.quality) quality = ` in ${copy.quality}`
  const template = PAIR_INTROS[pairSeed(tags) % PAIR_INTROS.length]

  return template({
    count: count.toLocaleString("en-US"),
    one: count === 1,
    scenes: count === 1 ? "scene" : "scenes",
    tone: copy?.tone ? `${copy.tone} ` : "",
    a,
    b,
    site: siteName,
    quality,
  })
}
